import React from 'react';
import { Button, Flex, Text } from '@applyboard/crystal-ui';
import { PlusOutlineIcon } from '@applyboard/ui-icons';
import { CourseMappingsTable } from '../components/CourseMappingsTable';
import { CourseMappingsPagination } from '../components/CourseMappingsPagination';
import { AddCourseMappingDialog } from '../components/AddCourseMappingDialog';
import { CountryFilter } from '../components/filters/CountryFilter';
import { Sort } from '../components/filters/Sort';
import { queryParameterContext } from '../context';

export function DesktopLayout() {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);

  return (
    <Flex pt={4} gap={8} direction="column">
      <Flex justify="between">
        <Flex direction="column">
          <Text variant="titleL">Course mappings</Text>
          <Text contrast="low">List of mappings between source courses and equivalent programs.</Text>
        </Flex>
        <Button intent="primary" leadIcon={PlusOutlineIcon} onClick={() => setIsDialogOpen(true)}>
          Add course mapping
        </Button>
      </Flex>
      <Flex gap={2} justify="between">
        <Filter as={<CountryFilter />} width="300px" />
        <Filter as={<Sort />} width="auto" />
      </Flex>
      <queryParameterContext.FilterSummary />
      <CourseMappingsTable />
      <CourseMappingsPagination />
      {isDialogOpen && <AddCourseMappingDialog onClose={() => setIsDialogOpen(false)} />}
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
